// extracted by mini-css-extract-plugin
module.exports = {"tipText":"binding-form_tipText_1Q3RM"};